module.exports = __webpack_public_path__ + "static/media/ve.b2cd5a9a.svg";